/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreatePOSLocalCashRedemptionRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {CreatePOSLocalCashRedemptionResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const createPOSLocalCashRedemption = (request: CreatePOSLocalCashRedemptionRequest, options?: CashRequestOptions) => post<CreatePOSLocalCashRedemptionRequest, CreatePOSLocalCashRedemptionResponse>("/2.0/cash/create-p-o-s-local-cash-redemption", request, {...options, rejectOnError: true })